import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import OvChartPanelContainer from "./OvChartPanelContainer";
import { purple } from "material-ui/colors";
import dimensions from "react-dimensions";
import Menu, { MenuItem } from "material-ui/Menu";
import { humanRoughNumber } from "./helpers/presentation";

import {
  XYPlot,
  XAxis,
  YAxis,
  HorizontalGridLines,
  VerticalGridLines,
  HorizontalBarSeries,
  Crosshair
} from "react-vis";
import { setQueryToEntity } from "./helpers/overviewUrl";
import { formatAccountsCrosshairTitle } from "./helpers/charts";

const styles = theme => ({
  root: {
    padding: 10,
    marginBottom: 20
  },
  dimButton: { color: theme.palette.action.disabled },
  xaxis: {
    height: 60,
    borderWidth: 1,
    borderColor: "red",
    borderStyle: "solid"
  }
});

const generateSeries = data => {
  const template = [
    {
      disabled: false,
      field: "cores",
      title: "Cores",
      color: purple[400],
      data: []
    }
  ];
  data.forEach(el => {
    template[0].data.push({
      y: el.name,
      x: el.cores
    });
  });

  return template;
};

class OvAccountsCoresChart extends Component {
  constructor(props) {
    super(props);

    this.onBarClick = this.onBarClick.bind(this);
    this.handleRequestMenuClose = this.handleRequestMenuClose.bind(this);
    this.handleNavTimeChart = this.handleNavTimeChart.bind(this);
    this.handleNavAccount = this.handleNavAccount.bind(this);

    this.handleValueMouseOver = this.handleValueMouseOver.bind(this);
    this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
    this.formatCrosshairItems = this.formatCrosshairItems.bind(this);

    this.state = {
      crosshairValues: [],
      series: generateSeries(props.data),
      menuAnchor: null,
      menuOpen: false,
      menuAccount: {}
    };
  }

  handleValueMouseOver(datapoint, event) {
    const { series } = this.state;
    const index = series[0].data.findIndex(el => el.y === datapoint.y);
    this.setState({
      crosshairValues: series.map(s => s.data[index])
    });
  }

  mouseLeaveHandler() {
    this.setState({ crosshairValues: [] });
  }

  formatCrosshairItems(values) {
    const { series } = this.state;
    return values.map((v, i) => {
      return {
        title: series[i].title,
        value: humanRoughNumber(v.x, 2)
      };
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      series: generateSeries(nextProps.data)
    });
  }

  onBarClick(datapoint, event) {
    this.setState({
      menuOpen: true,
      menuAnchor: event.event.currentTarget,
      menuAccount: datapoint.y.split("|")[0]
    });
  }

  handleRequestMenuClose() {
    this.setState({ menuOpen: false });
  }

  handleNavTimeChart() {
    this.setState({ menuOpen: false });
    const { filterState, history } = this.props;
    history.push(
      setQueryToEntity(filterState, "time", {
        key: "account",
        value: { id: this.state.menuAccount }
      })
    );
  }
  handleNavAccount() {
    this.setState({ menuOpen: false });
    const { history } = this.props;
    history.push(`/accounts/${this.state.menuAccount}/settings`);
  }

  renderSeries() {
    const result = [];

    const s = this.state.series[0];
    result.push(
      <HorizontalBarSeries
        onValueMouseOver={this.handleValueMouseOver}
        key={0}
        color={s.color}
        data={s.data}
        onValueClick={this.onBarClick}
      />
    );

    return result;
  }

  plotHeight() {
    const n = this.state.series && this.state.series[0].data.length;
    if (n < 3) {
      return 150;
    }
    return n * 30 + 50;
  }

  renderPlot() {
    const { containerWidth, classes } = this.props;
    const plotWidth = containerWidth - 60;

    return (
      <XYPlot
        onMouseLeave={this.mouseLeaveHandler}
        margin={{ left: 200, bottom: 50 }}
        className={classes.plot}
        width={plotWidth}
        height={this.plotHeight()}
        yType="ordinal"
        stackBy="x"
      >
        <XAxis
          tickFormat={v => `${humanRoughNumber(v, 2)}`}
          tickLabelAngle={-30}
        />
        <YAxis tickFormat={v => v.split("|")[1]} />
        <VerticalGridLines />
        <HorizontalGridLines />
        {this.renderSeries()}
        <Crosshair
          itemsFormat={this.formatCrosshairItems}
          titleFormat={formatAccountsCrosshairTitle}
          values={this.state.crosshairValues}
        />
      </XYPlot>
    );
  }

  render() {
    const { loading } = this.props;

    return (
      <div>
        <OvChartPanelContainer
          chartSubheader=""
          chartTitle="Cores"
          loading={loading}
          chart={this.renderPlot()}
        />

        <Menu
          anchorEl={this.state.menuAnchor}
          open={this.state.menuOpen}
          onRequestClose={this.handleRequestMenuClose}
        >
          <MenuItem dense onClick={this.handleNavTimeChart}>
            See this account in time chart
          </MenuItem>
          <MenuItem dense onClick={this.handleNavAccount}>
            Go to account page
          </MenuItem>
          <MenuItem dense onClick={this.handleRequestMenuClose}>
            Close
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

OvAccountsCoresChart.propTypes = {
  data: PropTypes.array.isRequired,
  filterState: PropTypes.object.isRequired,
  containerWidth: PropTypes.number.isRequired
};

export { OvAccountsCoresChart };

export default withStyles(styles, { name: "OvAccountsCoresChart" })(
  dimensions({ elementResize: true })(OvAccountsCoresChart)
);



// WEBPACK FOOTER //
// ./src/OvAccountsCoresChart.js